<div *ngIf="loaderService.isLoading | async" id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
</div>
<div *ngIf="!(loaderService.isLoading | async)" style="height:80%;">

</div>